module.exports = __webpack_public_path__ + "img/logo.add8a13b.png";